import React from 'react';

type Props = {
  className?: string;
};

const MasterCardIcon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="74" height="52" fill="none" viewBox="0 0 74 52" className={className}>
    <path fill="#FF5F00" d="M44.243 12.374H29.078v27.252h15.165V12.374z"></path>
    <path
      fill="#EB001B"
      d="M30.041 26a17.442 17.442 0 016.596-13.626c-7.51-5.922-18.439-4.622-24.36 2.937-5.874 7.511-4.574 18.393 2.984 24.315a17.284 17.284 0 0021.424 0A17.342 17.342 0 0130.04 26z"
    ></path>
    <path
      fill="#F79E1B"
      d="M64.704 26c0 9.581-7.75 17.333-17.331 17.333-3.9 0-7.655-1.3-10.688-3.707 7.51-5.922 8.81-16.804 2.889-24.363-.867-1.06-1.83-2.07-2.89-2.889 7.511-5.922 18.44-4.622 24.313 2.937A17.157 17.157 0 0164.704 26z"
    ></path>
  </svg>
);

export default MasterCardIcon;
